import { Controller } from '@hotwired/stimulus'

export default class ToasterController extends Controller {
  connect() {
    // Плавное появление
    this.element.style.transition = 'opacity 0.3s ease'
    this.element.style.opacity = '1'

    // Автоматическое закрытие через 15 секунд
    this.timer = setTimeout(() => this.close(), 15000)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  /**
   * Закрывает уведомление с анимацией
   */
  close(event) {
    if (event) event.preventDefault()
    this.element.style.opacity = '0'
    setTimeout(() => this.element.remove(), 300)
  }
}
